export const es: Record<string, string> = {
  // Nav & System Drawer
  'nav.dashboard': 'Panel Principal',
  'nav.focus': 'Enfoque Diario y Hoja de Ruta',
  'nav.ai_assistant': 'Motor Operativo Automatizado',
  'nav.calendar': 'Google Calendar',
  'nav.book': 'Página Pública de Reservas',
  'nav.bookings': 'Reservas e Ingresos',
  'nav.invoices': 'Facturas',
  'nav.expenses': 'Gastos',
  'nav.settings': 'Sede de Negocios e Impuestos',
  'nav.billing': 'Suscripciones y Planes',
  'nav.j_lens': 'Bóveda J-Lens',
  'nav.concept': 'Concepto y Mentalidad',
  'nav.what_is': '¿Qué es AzuraOS?',
  'nav.export': 'Exportar y Respaldar',
  'nav.menu': 'Menú',
  'nav.welcome': 'Bienvenida y Hub BYOK',
  'nav.app_stack_modules': 'Módulos del Sistema',
  'nav.core_engines': '8 Motores Principales',
  'nav.manifesto': 'Sistema y Manifiesto de Fundadores',
  'nav.workspace_actions': 'Acciones de Trabajo',
  'nav.export_records': 'Exportar Registros',
  'nav.load_demo': 'Cargar Entorno Demo',
  'nav.partnerships': 'Alianzas y Respaldo',
  'nav.request_partnership': 'Solicitar Acceso de Alianza',
  'nav.partner_subtext': 'Integraciones bancarias, cohortes y patrocinios',
  'nav.interface_language': 'Idioma de Interfaz',
  'nav.legal_trust': 'Legal y Confianza',
  'nav.security': 'Seguridad',
  'nav.faqs': 'Preguntas Frecuentes',
  'nav.terms': 'Términos',
  'nav.privacy': 'Privacidad',
  'nav.refund': 'Política de Reembolso',
  'nav.contact': 'Contacto',
  'nav.report_bug': 'Reportar Error',
  'nav.invite_founder': '+ Invitar Fundador',
  'nav.privacy_active': 'Modo Privacidad: ACTIVO',
  'nav.privacy_off': 'Modo Privacidad: DESACTIVADO',
  'nav.masked': 'Oculto',
  'nav.visible': 'Visible',
  'nav.live_margin': 'MARGEN OPERATIVO EN VIVO',
  'nav.target_safe_zone': 'Zona Segura Objetivo:',
  'nav.close_menu': 'Cerrar Menú',
  'nav.founder_access': 'Iniciar Sesión / Acceso',
  'nav.private_vault': 'Bóveda Privada Conectada',
  'nav.master_access': 'Acceso Maestro Fundador',
  'nav.lifetime': 'De por Vida',
  'nav.pro_active': 'Soberano Pro Activo',
  'nav.trial_days': 'Prueba 7 Días: {days} días restantes',
  'nav.trial_expired': 'Prueba Expirada',
  'nav.manage': 'Gestionar →',
  'nav.upgrade': 'Mejorar →',
  'nav.unlock_pro': 'Desbloquear Pro →',

  // Dashboard Cards & Sections
  'dash.greeting_morning': 'Buenos días',
  'dash.greeting_afternoon': 'Buenas tardes',
  'dash.greeting_evening': 'Buenas noches',
  'dash.value_prop': 'Control multiflujo en un solo lugar: ingrese 1 flujo de ingresos y 1 gasto para ver el margen neto en tiempo real.',
  'dash.manage_streams': 'Gestionar Flujos de Ingresos',
  'dash.close_streams': 'Cerrar Flujos',
  'dash.income': 'Ingresos',
  'dash.collected': 'Cobrado',
  'dash.unpaid': 'Pendiente',
  'dash.expenses': 'Gastos',
  'dash.across_records': 'En registros',
  'dash.net_profit': 'Beneficio Neto',
  'dash.daily_focus_title': 'Enfoque Diario y Plan de Ingresos',
  'dash.daily_focus_sub': 'Tareas estratégicas de alto impacto que impulsan ganancias',
  'dash.open_focus': 'Abrir Hoja de Enfoque',
  'dash.stream_profitability': 'Rentabilidad por Flujo',
  'dash.stream_sub': '1 oferta o múltiples servicios • Margen en tiempo real',
  'dash.quick_actions': 'Acciones Rápidas',
  'dash.add_booking': 'Agregar Reserva',
  'dash.add_booking_desc': 'Registrar nuevo ingreso de cliente',
  'dash.add_expense': 'Registrar Gasto',
  'dash.add_expense_desc': 'Registrar costos operativos y comerciales',
  'dash.add_insight': 'Agregar Insight',
  'dash.add_insight_desc': 'Capturar nueva regla J-Lens',
  'dash.quick_add_title': 'Entrada Rápida',
  'dash.quick_revenue': '+ INGRESO RÁPIDO (RESERVA)',
  'dash.quick_expense': '+ GASTO RÁPIDO (LIBRO MAYOR)',
  'dash.recent_activity': 'Actividad Reciente',
  'dash.no_activity': 'No hay actividad reciente. Use las acciones rápidas para comenzar.',
  'dash.spotlight_insight': 'Insight Destacado J-Lens',
  'dash.access_vault': 'Acceder a la Bóveda →',
  'dash.sandbox_active': 'Entorno Demo Activo',
  'dash.load_demo_data': 'Cargar Datos Demo',
  'dash.clear_sandbox': 'Limpiar Demo',
  'dash.clear_confirm': '¿Borrar datos?',
  'dash.yes_clear': 'Sí, borrar',
  'dash.cancel': 'Cancelar',

  // Bookings View
  'bookings.title': '📅 Reservas y Flujos',
  'bookings.subtitle': 'Canales soberanos de ingresos de clientes',
  'bookings.public_page': 'Página Pública de Reservas',
  'bookings.import_csv': 'Importar CSV',
  'bookings.add_button': 'Agregar Reserva',
  'bookings.client_link_title': 'Enlace de Autoprogramación para Clientes',
  'bookings.client_link_desc': 'Comparta enlaces estándar o personalizados para agendamiento automático y sincronización con Google Calendar.',
  'bookings.link_active': 'Activo',
  'bookings.generate_custom_link': '⚡ Generar Enlace Personalizado',
  'bookings.hide_custom_link': 'Ocultar Enlace',
  'bookings.copy_standard_link': 'Copiar Enlace Estándar',
  'bookings.copied_link': '¡Enlace copiado!',
  'bookings.preview': 'Vista Previa',
  'bookings.search_placeholder': 'Buscar por cliente o servicio...',
  'bookings.filter_all': 'Todos los Flujos',
  'bookings.table_client': 'Nombre del Cliente',
  'bookings.table_stream': 'Flujo / Servicio',
  'bookings.table_date': 'Fecha',
  'bookings.table_amount': 'Monto',
  'bookings.table_status': 'Estado',
  'bookings.table_actions': 'Acciones',
  'bookings.mark_paid': 'Marcar como Pagado',
  'bookings.mark_unpaid': 'Marcar Pendiente',
  'bookings.delete': 'Eliminar',
  'bookings.no_records': 'No se encontraron reservas. Use "Agregar Reserva" o el enlace público.',

  // Invoices View
  'invoices.title': '📄 Facturas y Cobros de Clientes',
  'invoices.subtitle': 'Facturación profesional y conciliación de cobros',
  'invoices.create_invoice': 'Crear Nueva Factura',
  'invoices.tab_all': 'Todas las Facturas',
  'invoices.tab_paid': 'Facturas Pagadas',
  'invoices.tab_outstanding': 'Pendientes / En Trámite',
  'invoices.tab_overdue': 'Vencidas',
  'invoices.table_number': 'Factura N.º',
  'invoices.table_client': 'Cliente',
  'invoices.table_issue_date': 'Fecha de Emisión',
  'invoices.table_due_date': 'Fecha de Vencimiento',
  'invoices.table_total': 'Monto Total',
  'invoices.table_status': 'Estado',
  'invoices.download_pdf': 'Descargar PDF',
  'invoices.mark_as_paid': 'Marcar Pagado',
  'invoices.no_records': 'No se han generado facturas aún. Cree una para gestionar cobros.',

  // Expenses View
  'expenses.title': '💳 Gastos y Libro Mayor',
  'expenses.subtitle': 'Seguimiento de salidas y optimización de deducciones fiscales',
  'expenses.log_expense': 'Registrar Gasto',
  'expenses.import_csv': 'Importar CSV',
  'expenses.total_outflow': 'Salidas Totales',
  'expenses.tax_deductible': 'Deducible de Impuestos',
  'expenses.search_placeholder': 'Buscar por proveedor o descripción...',
  'expenses.filter_all': 'Todas las Categorías',
  'expenses.table_category': 'Categoría',
  'expenses.table_description': 'Descripción / Proveedor',
  'expenses.table_date': 'Fecha',
  'expenses.table_claimable': 'Deducible',
  'expenses.table_amount': 'Monto',
  'expenses.table_actions': 'Acciones',
  'expenses.claimable_yes': 'Sí (Deducible)',
  'expenses.claimable_no': 'No (Personal / No Deducible)',
  'expenses.no_records': 'No hay gastos registrados aún. Agregue costos para calcular márgenes reales.',

  // Daily Focus & Roadmap
  'focus.title': '🎯 Enfoque Diario y Plan de Ingresos',
  'focus.subtitle': 'Tareas estratégicas de alto rendimiento para maximizar flujo y rentabilidad',
  'focus.add_task': 'Agregar Tarea de Ingresos',
  'focus.active_tasks': 'Tareas Prioritarias Activas',
  'focus.completed_tasks': 'Tareas Completadas',
  'focus.high_leverage': 'Alto Impacto',
  'focus.mark_done': 'Completar',
  'focus.delete_task': 'Eliminar',
  'focus.no_tasks': '¡Todo al día! Agregue una tarea estratégica para mantener el impulso.',

  // Automated Operational Engine
  'ai.title': '⚡ Motor Operativo Automatizado',
  'ai.subtitle': 'Cálculos cifrados del lado del cliente e inteligencia operativa soberana (Sin retención de datos)',
  'ai.ask_placeholder': 'Consulte sobre flujo de caja, optimización de márgenes o estrategia de precios...',
  'ai.send': 'Analizar',
  'ai.thinking': 'El motor operativo está procesando sus cálculos financieros...',
  'ai.prompt_margin': '¿Cómo puedo aumentar mi margen de beneficio neto al 60%?',
  'ai.prompt_tax': '¿Qué gastos debo registrar para optimizar mi reserva fiscal?',
  'ai.prompt_pricing': '¿Cómo debería estructurar mis paquetes de servicios mensuales?',
  'ai.clear_chat': 'Borrar Historial',

  // Business & Tax HQ
  'hq.title': '🏢 Sede de Negocios e Impuestos',
  'hq.subtitle': 'Perfil, moneda, reglas fiscales, preajustes de jurisdicción y auditorías contables',
  'hq.tab_profile': 'Perfil e Identidad',
  'hq.tab_currency_tax': 'Reglas de Moneda e Impuestos',
  'hq.tab_accountant_view': 'Vista para Contador y Auditoría CPA',
  'hq.tab_exports': 'Exportaciones y Respaldos',
  'hq.tab_security': 'Seguridad y Privacidad',
  'hq.jurisdiction_preset_title': 'Preajuste Regional de Jurisdicción',
  'hq.jurisdiction_preset_desc': 'Seleccione su país para configurar automáticamente la moneda local, el IVA/impuesto y las entidades fiscales.',
  'hq.accountant_view_title': 'Vista para Contador y Auditoría CPA',
  'hq.accountant_view_desc': 'Resumen estandarizado de precontabilidad listo para contadores externos o evaluaciones bancarias.',
  'hq.export_pdf_audit': 'Estado de Auditoría en PDF',
  'hq.export_csv_audit': 'Exportar CSV de Auditoría',
  'hq.currency_symbol': 'Símbolo de Moneda',
  'hq.currency_code': 'Código de Moneda',
  'hq.vat_rate': 'Tasa de IVA / Impuesto (%)',
  'hq.tax_authority': 'Nombre de la Autoridad Fiscal',
  'hq.save_settings': 'Guardar Configuración Comercial',

  // Financial & Metric Labels
  'metric.gross_revenue': 'Ingresos Brutos',
  'metric.total_expenses': 'Gastos Totales',
  'metric.net_profit': 'Ingreso Operativo Neto',
  'metric.profit_margin': 'Margen de Beneficio Operativo',
  'metric.active_bookings': 'Reservas Activas',
  'metric.paid_invoices': 'Facturas Pagadas',
  'metric.unpaid_invoices': 'Pendientes / Vencidas',
  'metric.tax_buffer': 'Reserva Fiscal Estimada',
  'metric.currency': 'Moneda Operativa',
  'metric.tax_rate': 'Tasa de Impuesto / IVA',

  // Actions & Common Buttons
  'btn.save': 'Guardar Cambios',
  'btn.cancel': 'Cancelar',
  'btn.download': 'Descargar',
  'btn.export_pdf': 'Descargar Reporte en PDF',
  'btn.export_csv': 'Exportar como CSV',
  'btn.cpa_pack': 'Exportar Paquete Contable',
  'btn.new_booking': 'Registrar Reserva',
  'btn.new_expense': 'Registrar Gasto',
  'btn.add_task': 'Agregar Tarea',
  'btn.sync_calendar': 'Sincronizar Google Calendar',
  'btn.privacy_mode': 'Modo Privacidad',
  'btn.manage_subscription': 'Gestionar Suscripción',
  'btn.sign_in': 'Iniciar Sesión / Acceso',
  'btn.sign_out': 'Cerrar Sesión',
  'btn.delete': 'Eliminar',
  'btn.edit': 'Editar',
  'btn.close': 'Cerrar',

  // Statuses
  'status.paid': 'Pagado',
  'status.unpaid': 'Pendiente',
  'status.overdue': 'Vencido',
  'status.safe': 'Margen Saludable',
  'status.warning': 'Alerta de Margen',
  'status.trial_active': 'Prueba Gratuita Activa',
  'status.pro_active': 'Soberano Pro',
};
